import '../css/styles.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import NavButton from '../components/NavButton';
import Footer from '../components/Footer';
import { useState, useEffect } from 'react';

function Gallery(){
    const navigate = useNavigate();
    const [buttonWidth, setButtonWidth] = useState("25%");
    const [buttonHeight, setButtonHeight ] = useState("400px");

    const solutions = [
        "All Ceramic",
        "PFM",
        "Implants",
        "Full Gold",
        "3D Printing",
        "Milling",
        "Long Term Temps",
        "Full Arch Zirconia",
        "Tech Info",
    ]; 

    const solutionsImg = [
        "/img/all-ceramic.png",
        "/img/porcelain-fused-to-metal.png",
        "/img/implant.png",
        "/img/IMG_3693.png",
        "/img/3d-printing.png",
        "/img/milling.png",
        "/img/long-term-temps.png",
        "/img/full-arch-zirconia.png",
        "/img/tech-info.png"
    ]

    useEffect(() => {
        const updateButtonWidth = () => {
            if(window.innerWidth <= 440){
                setButtonWidth("90%");
                setButtonHeight("12.5rem");
            } else if(window.innerWidth <= 1300){
                setButtonWidth("45%");
                setButtonHeight("400px");
            } else {
                setButtonWidth("25%");
                setButtonHeight("400px");
            }
        };

        updateButtonWidth();
        window.addEventListener("resize", updateButtonWidth);
        return () => window.removeEventListener("resize", updateButtonWidth);
    }, [])

    return(
        <div className='page-wrapper gallery-page'>
            <NavBar/>
            <main>
                <h1 style={{textAlign:  'center'}}>Solutions</h1>
                <div className='button-grid'>
                    {solutions.map((text, index) => (
                        <NavButton key={index} text={text} img={solutionsImg[index]} link={`/gallery/${text.toLowerCase().replace(/\s+/g, '').replace(/[^a-z-]/g, '')}`} width={buttonWidth} height={buttonHeight}/>
                    ))}
                </div>
            </main>
            <Footer/>
        </div>
    )
}
export default Gallery;